import React from 'react';

import Modal from './Modal';
import LocationPickerContent from './LocationPickerContent';

export default function LocationPickerModal({ open, onClose, addresses, onResolved }) {
  const handleResolved = () => {
    onResolved?.();
    onClose?.();
  };

  return (
    <Modal open={open} onClose={onClose} title="Delivery location" maxWidth={480}>
      <LocationPickerContent addresses={addresses} onResolved={handleResolved} />
    </Modal>
  );
}
